import React, { useState, useEffect, useMemo } from 'react';
import './YearRangeSlider.css';

const YearRangeSlider = ({ selectedRange, onChange }) => {
  const minYear = 2010;
  const maxYear = 2025;

  const [startYear, setStartYear] = useState(minYear);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (Array.isArray(selectedRange) && selectedRange.length === 2) {
      const incomingStart = Math.min(Math.max(selectedRange[0], minYear), maxYear);
      setStartYear(incomingStart);
      setIsActive(incomingStart !== minYear);
    } else {
      setStartYear(minYear);
      setIsActive(false);
    }
  }, [selectedRange]);

  const handleChange = (event) => {
    const value = Number(event.target.value);
    setStartYear(value);
    setIsActive(value !== minYear);
    if (typeof onChange === 'function') {
      onChange([value, maxYear]);
    }
  };

  const resetFilter = () => {
    setStartYear(minYear);
    setIsActive(false);
    if (typeof onChange === 'function') {
      onChange([]);
    }
  };

  const displayLabel = useMemo(() => `${startYear} - ${maxYear}`, [startYear, maxYear]);
  const progress = useMemo(() => {
    const raw = ((startYear - minYear) / (maxYear - minYear)) * 100;
    return Math.min(Math.max(raw, 0), 100);
  }, [startYear, minYear, maxYear]);

  const sliderStyle = useMemo(() => ({
    background: `linear-gradient(90deg, #0f172a 0%, #0f172a ${progress}%, #e2e8f0 ${progress}%, #e2e8f0 100%)`
  }), [progress]);

  return (
    <div className="year-range-slider">
      <div className="slider-header">
        <span className="slider-label">Année</span>
        {isActive && (
          <button type="button" className="reset-slider-btn" onClick={resetFilter}>
            ×
          </button>
        )}
      </div>

      <div className="slider-body">
        <input
          type="range"
          min={minYear}
          max={maxYear}
          value={startYear}
          onChange={handleChange}
          className="year-slider"
          style={sliderStyle}
          aria-label="Année de début"
        />
        <span className="range-output">{displayLabel}</span>
      </div>
    </div>
  );
};

export default YearRangeSlider;




